import {userRoleList} from "./constants";

const hasText = (value) =>
  typeof value === "string" && value.trim().length > 0;

const hasItems = (value) => Array.isArray(value) && value.length > 0;

const resultFromChecks = (role, checks) => {
  const missingFields = checks
    .filter(([, completed]) => !completed)
    .map(([field]) => field);

  return {
    role,
    isReady: true,
    isComplete: missingFields.length === 0,
    missingFields,
    percentage: Math.round(
      ((checks.length - missingFields.length) / checks.length) * 100,
    ),
  };
};

const emptyResult = (role = null) => ({
  role,
  isReady: false,
  isComplete: false,
  missingFields: [],
  percentage: 0,
});

export const getProfileCompletion = (
  user,
  {stripeStatus, stripeStatusLoaded = false} = {},
) => {
  if (user?.selectedRole === userRoleList.TECHNICIAN) {
    const technician = user.Technician;
    const associationsReady = Boolean(
      technician &&
        Array.isArray(technician.InterventionAreas) &&
        Array.isArray(technician.SubCategories) &&
        Array.isArray(technician.BankAccounts) &&
        Object.prototype.hasOwnProperty.call(technician, "paymentFrequency"),
    );

    if (!associationsReady) return emptyResult(userRoleList.TECHNICIAN);

    const hasBankAccount = hasItems(technician.BankAccounts);
    if (hasBankAccount && !stripeStatusLoaded) {
      return emptyResult(userRoleList.TECHNICIAN);
    }

    const checks = [
      [
        "address",
        hasText(user.address) && hasText(user.city) && hasText(user.zipCode),
      ],
      ["bio", hasText(technician.bio)],
      ["interventionAreas", hasItems(technician.InterventionAreas)],
      ["sectors", hasItems(technician.SubCategories)],
      ["bankAccount", hasBankAccount],
      ["paymentFrequency", hasText(technician.paymentFrequency)],
    ];

    if (hasBankAccount) {
      checks.splice(checks.length - 1, 0, [
        "stripeValidation",
        stripeStatus?.ready === true &&
          stripeStatus?.bankAccountValidated === true,
      ]);
    }

    return resultFromChecks(userRoleList.TECHNICIAN, checks);
  }

  if (user?.selectedRole === userRoleList.CLIENT) {
    if (!user.Client || typeof user.verifiedEmail !== "boolean") {
      return emptyResult(userRoleList.CLIENT);
    }

    return resultFromChecks(userRoleList.CLIENT, [
      [
        "address",
        hasText(user.address) && hasText(user.city) && hasText(user.zipCode),
      ],
      ["emailVerification", user.verifiedEmail === true],
    ]);
  }

  return emptyResult();
};
